module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0700.99386a5a.jpg";